import React from 'react';
import { GamesBreadcrumb } from './index';
import { PlayGameLink } from './index';

export default function ClosestGuessPage() {
  return (
    <div className="mx-auto rounded-xl bg-white p-4 shadow dark:bg-slate-900/80">
      <GamesBreadcrumb game="Closest Guess" />
      <h1 className="mb-4 text-3xl font-bold text-slate-900 dark:text-slate-100">Closest Guess</h1>
      <img
        src="/thumbnails/ClosestGuess.png"
        alt="Closest Guess game screenshot"
        className="mx-auto mb-4 w-full max-w-md rounded-lg bg-white shadow dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">About Closest Guess</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Closest Guess turns trivia-style numbers into a race for precision. Everyone sees the same question at once, writes a private guess, and the player with the closest answer wins the round.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc space-y-1 pl-6 text-gray-700 dark:text-gray-300">
          <li>Each round presents a numeric question such as a population, distance, or measurement.</li>
          <li>Players enter their best guess before the timer expires.</li>
          <li>Once all guesses are in, the closest answer scores the most points.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">Why it’s fun</h2>
        <p className="text-gray-700 dark:text-gray-300">
          The game is simple to grasp but surprisingly tense when the answers are close. It is great for mixed groups because everyone can jump in quickly and compare their instincts.
        </p>
      </section>
      <section>
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">Play Closest Guess</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Gather a group and see who can estimate the closest answer. Play it live with friends on the lobby for free.
        </p>
        <PlayGameLink game="ClosestGuess" gameTitle="Closest Guess" />
      </section>
    </div>
  );
}
